/* assets/section-image-marquee.js */
if (!customElements.get('image-marquee')) {
  class ImageMarquee extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('[data-image-marquee-row]');
      this.pauseOnHover = this.hasAttribute('data-pause-on-hover');
      this.onItemEnter = this.onItemEnter.bind(this);
      this.onItemLeave = this.onItemLeave.bind(this);
      this.bindEvents();
    }

    disconnectedCallback() {
      this.unbindEvents();
    }

    bindEvents() {
      if (!this.pauseOnHover || !this.row) return;

      this.querySelectorAll('.image-marquee__item').forEach((item) => {
        item.addEventListener('mouseenter', this.onItemEnter);
        item.addEventListener('mouseleave', this.onItemLeave);
        item.addEventListener('focusin', this.onItemEnter);
        item.addEventListener('focusout', this.onItemLeave);
      });
    }

    unbindEvents() {
      this.querySelectorAll('.image-marquee__item').forEach((item) => {
        item.removeEventListener('mouseenter', this.onItemEnter);
        item.removeEventListener('mouseleave', this.onItemLeave);
        item.removeEventListener('focusin', this.onItemEnter);
        item.removeEventListener('focusout', this.onItemLeave);
      });
    }

    onItemEnter() {
      if (this.row) this.row.classList.add('is-paused');
    }

    onItemLeave() {
      if (this.row) this.row.classList.remove('is-paused');
    }
  }

  customElements.define('image-marquee', ImageMarquee);
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('image-marquee').forEach((el) => {
    if (typeof el.disconnectedCallback === 'function') el.disconnectedCallback();
    if (typeof el.connectedCallback === 'function') el.connectedCallback();
  });
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('image-marquee').forEach((el) => {
    if (typeof el.disconnectedCallback === 'function') el.disconnectedCallback();
  });
});
